import { galleryItems } from "@/mocks/news";

export default function OnsiteGallery() {
  return (
    <section id="onsite" className="bg-foreground-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-primary-400 text-xs font-semibold tracking-[0.25em] mb-2">ONSITE · 在场目击</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">镜头里的一手现场</h2>
          </div>
          <p className="text-sm text-background-300 max-w-sm leading-relaxed">
            每一张图片都来自在场记者与核实过的目击者，还原现场最真实的氛围与细节。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {galleryItems.map((g, i) => (
            <figure
              key={g.id}
              className={`group relative overflow-hidden rounded-lg cursor-pointer ${
                i % 3 === 0 ? "md:row-span-2 md:aspect-auto aspect-[3/4]" : "aspect-[3/4]"
              }`}
            >
              <img
                src={g.image}
                alt={`${g.title} 在场现场照片`}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <figcaption className="absolute inset-0 flex flex-col justify-end p-4 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-90 group-hover:opacity-100">
                <span className="inline-flex w-fit items-center rounded-full bg-primary-500 text-background-50 text-[10px] px-2.5 py-0.5 mb-2">
                  {g.cat}现场
                </span>
                <span className="font-heading font-bold text-background-50 leading-snug">{g.title}</span>
                <span className="mt-1 inline-flex items-center gap-1 text-[11px] text-background-300">
                  <i className="ri-map-pin-2-line" /> {g.location}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}